import { SettingsCustomFormFieldData } from '../../../models/settings/settings-custom-form-field-data.class';
import { FieldDataInterface } from '../../../models/settings/settings-custom-form-field-data.model';

export class SettingsShortTextV1Field extends SettingsCustomFormFieldData {

    // constructor(type:string, field?:FieldDataInterface) {
    //   super(type, field);
    // }

    public serialize(): FieldDataInterface {
        return this._serialize({});
    }

    public deserialize(field: FieldDataInterface): SettingsShortTextV1Field {
        const self = new SettingsShortTextV1Field(field.type, field.position, field.id, field.label, field.mandatory, field.active);
        return self;
    }


    public update(updateData: Partial<SettingsShortTextV1Field>) : SettingsShortTextV1Field {
        // Create a new instance with the initial data
        const self = new SettingsShortTextV1Field(
            this.type,
            this.position,
            this.id,
            this.label,
            this.mandatory,
            this.active,
        );

        // Apply any updates provided in updateData
        if (updateData) {
            Object.assign(self, updateData);
            // mark the field as changed    
            self.changed = true;
        }
        
        return self;
        
    }

}
